<template>
  <b-modal id="add_invoice_template" ref="add_invoice_template" hide-footer no-close-on-backdrop no-close-on-esc>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1><i class="fas fa-file-invoice"></i> <span>Add Invoice Template</span></h1>
        <p id="mh-info">Add invoice template for {{ return_company_name }}</p>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <ValidationObserver ref="addInvoiceTemplate" slim>
      <form role="form" @submit.prevent="submit_form">
        <div class="row">
          <!-- invoice template -->
          <ValidationProvider rules="required" v-slot="{errors, classes}" name="Invoice Template" tag="div" class="col-12 form-group">
            <label class="form-label" for="invoice_template">Invoice Template</label>
            <multiselect v-model="template.invoice_template" id="invoice_template" name="invoice_template" placeholder=""
                         :options="ms_opts.invoice_templates" :class="classes" class="requiredField"></multiselect>
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <!-- batch type -->
          <ValidationProvider rules="required" v-slot="{errors, classes}" name="Batching Type" tag="div" class="col-12 form-group">
            <label class="form-label" for="batch_type">Batching Type</label>
            <multiselect v-model="template.batch_type" id="batch_type" name="batch_type" placeholder="" class="requiredField"
                         :options="ms_opts.batch_types" label="value" track-by="ident" :class="classes"></multiselect>
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <!-- line type -->
          <ValidationProvider rules="required" v-slot="{errors, classes}" name="Line Type" tag="div" class="col-12 form-group">
            <label class="form-label" for="line_type">Line Type</label>
            <multiselect v-model="template.line_type" id="line_type" name="line_type" placeholder="" class="requiredField"
                         :options="ms_opts.line_types" label="value" track-by="ident" :class="classes"></multiselect>
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <!-- additions inclusive -->
          <div class="col-12">
            <div class="row">
              <label class="col-8 cardLabel font-weight-bold">Additions Inclusive (If applicable)</label>
              <div class="col-4 form-group">
                <bootstrap-toggle v-model="template.additions_inclusive" id="additions_inclusive" name="additions_inclusive"
                                  :options="{on: 'Yes', off: 'No'}"/>
              </div>
            </div>
          </div>
          <!-- margin inclusive -->
          <div class="col-12">
            <div class="row">
              <label class="col-8 cardLabel font-weight-bold">Margin Inclusive (If applicable)</label>
              <div class="col-4 form-group">
                <bootstrap-toggle v-model="template.margin_inclusive" id="margin_inclusive" name="margin_inclusive"
                                  :options="{on: 'Yes', off: 'No'}"/>
              </div>
            </div>
          </div>
          <!-- reverse vat applied (JUST GM AND CONTRACTOR invoice template) -->
          <div class="col-12" v-if="showReverseVAT">
            <div class="row">
              <label class="col-8 cardLabel font-weight-bold">Reverse VAT applied</label>
              <div class="col-4 form-group">
                <bootstrap-toggle v-model="template.reverse_vat_applied" id="reverse_vat_applied" name="reverse_vat_applied"
                                  :options="{on: 'Yes', off: 'No'}"/>
              </div>
            </div>
          </div>
          <!-- Email to -->
          <ValidationProvider rules="required" v-slot="{errors, classes}" name="Email To" tag="div" class="col-12 form-group">
            <label class="form-label" for="email_to">Email to</label>
            <multiselect v-model="template.email_to" id="email_to" name="email_to" placeholder="" :class="classes" class="requiredField"
            :options="ms_opts.email_to" :multiple="true" :taggable="true" @tag="addEmailToTag" :tagPlaceholder="'Press enter to add email address'"></multiselect>
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <!-- Email CC -->
          <ValidationProvider rules="" v-slot="{errors, classes}" name="Email CC" tag="div" class="col-12 form-group">
            <label class="form-label" for="email_cc">Email CC</label>
            <multiselect v-model="template.email_cc" id="email_cc" name="email_cc" placeholder=""
                         :options="ms_opts.email_cc" :multiple="true" :taggable="true" @tag="addEmailCcTag" :tagPlaceholder="'Press enter to add email address'"></multiselect>
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>


          <div class="col-12 mt-2 mb-2 text-center" v-if="showPreviewLink">
            <a href="#"><i>preview</i></a>
          </div>
          <div class="col-6 offset-6">
            <button class="btn orcaBtn w-100 mt-3">Save</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import BootstrapToggle from "vue-bootstrap-toggle";

export default {
  name: "add_invoice_template",
  components: {
    Multiselect,
    BootstrapToggle
  },
  data() {
    return {
      ms_opts: {
        invoice_templates: ['CONTRACTOR', 'PAYE'],
        batch_types: [
          {ident: 'batched_by_vat', value: 'VAT'},
          {ident: 'batched_by_site', value: 'Site'},
          {ident: 'batched_by_po_number', value: 'PO Number'},
          {ident: 'batched_by_job_title', value: 'Job Title'},
        ],
        line_types: [
          {ident: 'list_by_worker', value: 'List by worker'},
          {ident: 'group_by_worker', value: 'Group by worker'},
          {ident: 'group_by_site', value: 'Group by site'}
        ],
        email_to: [],
        email_cc: [],
      },
      template: {
        company_id: this.$store.state.companies.invoice_templates_modal.company_id,
        invoice_template: null,
        batch_type: null,
        line_type: null,
        additions_inclusive: true,
        margin_inclusive: true,
        reverse_vat_applied: false,
        email_to: [],
        email_cc: [],
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      }
    }
  },
  computed: {
    /**
     * Return the company name whose invoice template is being edited
     * @returns {string}
     */
    return_company_name() {
      return this.$store.state.companies.invoice_templates_modal.company_name
    },
    /**
     * Only show reverse VAT for Payroll CRM and CONTRACTOR invoice template
     * @returns {boolean}
     */
    showReverseVAT() {
      return this.crmType === 'payroll' && this.template.invoice_template === 'CONTRACTOR';
    },
    /**
     * Whether to show the link to preview what an invoice will look like (if form is filled in or not)
     * @returns {boolean}
     */
    showPreviewLink() {
      return this.template.invoice_template !== null && this.template.batch_type !== null &&
          this.template.line_type !== null;
    }
  },
  beforeMount() {
    /*
     * check if the company has templates for either Contractor or Paye already
     * and remove from multiselect accordingly and set the only remaining value
     * can only have one of each template type
     */
    if (this.$store.state.companies.invoice_templates_modal.hasContractorInvoiceTemplate) {
      this.ms_opts.invoice_templates.splice(this.ms_opts.invoice_templates.indexOf('CONTRACTOR'), 1)
      this.template.invoice_template = "PAYE"
    }
    if (this.$store.state.companies.invoice_templates_modal.hasPayeInvoiceTemplate) {
      this.ms_opts.invoice_templates.splice(this.ms_opts.invoice_templates.indexOf('PAYE'), 1)
      this.template.invoice_template = "CONTRACTOR"
    }
  },
  methods: {
    /**
     * Hide this template modal
     */
    hideModal() {
      this.$refs.add_invoice_template.hide();
      this.$store.commit('HIDE_INVOICE_TEMPLATE_MODALS');
    },
    /**
     * Handle adding a new email address to the email_to field
     * @param new_email_to
     */
    addEmailToTag(new_email_to) {
      let email_format = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
      // if the entered email address is a valid format then add to email_to
      if (new_email_to.match(email_format)) {
        this.ms_opts.email_to.push(new_email_to)
        this.template.email_to.push(new_email_to)
      }
      // catch any invalid format emails trying to be added and alert to the user
      else {
        alert('The email you have entered is not a valid format.')
      }
    },
    /**
     * Handle adding a new email address to the email_cc field
     * @param new_email_cc
     */
    addEmailCcTag(new_email_cc) {
      let email_format = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
      // if the entered email address is a valid format then add to email_to
      if (new_email_cc.match(email_format)) {
        this.ms_opts.email_cc.push(new_email_cc)
        this.template.email_cc.push(new_email_cc)
      }
      // catch any invalid format emails trying to be added and alert to the user
      else {
        alert('The email you have entered is not a valid format.')
      }
    },
    /**
     * Trigger Validation and submit the form to the backend to save the template information
     */
    submit_form() {
      this.$refs.addInvoiceTemplate.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.addInvoiceTemplate);
        }
        else {
          this.template.batch_type = this.template.batch_type.ident
          this.template.line_type = this.template.line_type.ident
          axios.post(this.crmApiPath + 'company/invoice_settings', this.template).then(() => {
            this.$bus.$emit('logs::reload', {action: true});
            this.$bus.$emit('company::reload', {action: true});
            this.hideModal();
          })
        }
      })
    }
  },
  watch: {
    'template.invoice_template'(val) {
      if (val === 'PAYE') {
        this.template.reverse_vat_applied = false
      }
    }
  }
}
</script>
